import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { siteLang } from "../../lib/siteLang";

// Handles Emergent Google OAuth redirect: #session_id=...
const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) { navigate("/signin", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId, language: siteLang() });
        loginWithToken(data.token, data.user);
        window.history.replaceState(null, "", "/");
        if (data.needs_role) navigate("/role", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (e) {
        navigate("/signin", { replace: true });
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0D0D0D]">
      <div className="w-10 h-10 border-2 border-[#FF5C00] border-t-transparent rounded-full animate-spin" />
    </div>
  );
};

export default AuthCallback;
